"use strict";

export default d => d;